<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-callout section="group-billing" shadow></page-callout>

        <page-header>Billing Details</page-header>

        <group-billing-email
            :teamId="props.group.team_id"
            :groupId="props.group.group_id"
            :billingEmail="props.group.billing_email"
            :isEditable="isEditable"
        />

        <group-billing-info
            :teamId="props.group.team_id"
            :groupId="props.group.group_id"
            :billingInformation="{
                billing_company_legal_name: props.group.billing_company_legal_name ?? null,
                billing_address: props.group.billing_address ?? null,
                billing_address_line_2: props.group.billing_address_line_2 ?? null,
                billing_city: props.group.billing_city ?? null,
                billing_state: props.group.billing_state ?? null,
                billing_zip: props.group.billing_zip ?? null,
                billing_country: props.group.billing_country ?? null,
                billing_po_number: props.group.billing_po_number ?? null,
            }"
            :isEditable="isEditable"
        />

        <group-stripe-payment-method
            v-if="isEditable && stripeKey"
            id="group-payment-method"
            :teamId="props.group.team_id"
            :groupId="props.group.group_id"
            :paymentMethod="{ card_brand: props.group.card_brand ?? null, card_last_four: props.group.card_last_four ?? null }"
            :stripeKey="stripeKey"
            :stripeApiVersion="stripeApiVersion"
        />
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import GroupBillingEmail from '~/components/settings/billing/GroupBillingEmail.vue';
import GroupBillingInfo from '~/components/settings/billing/GroupBillingInfo.vue';
import GroupStripePaymentMethod from '~/components/settings/billing/GroupStripePaymentMethod.vue';
import { computed } from 'vue';

const props = defineProps({
    group: {
        type: Object,
        required: true,
    },
    isAdminOrOwner: {
        type: Boolean,
        default: false,
    },
});

const stripeKey = Spark.stripeKey;
const stripeApiVersion = Spark.stripeApiVersion;

const isEditable = computed(() => props.isAdminOrOwner && props.group.is_billable);
</script>
